
const account_route = [
  {
    path: 'account',
    name: "account",
    component: resolve => {
      require(["@/views/account/Index.vue"], resolve);
    },
    meta: { title: "账号中心" },
    redirect: { path: "/user/account/infoIndex" },
    children: [
      {
        path: "infoIndex",
        name: "infoIndex",
        component: resolve => {
          require(["@/views/account/userInfo/UserInfoIndex.vue"], resolve);
        },
        meta: { title: "基本信息" },
        redirect: { path: "/user/account/infoIndex/info" },
        children: [
          {
            path: "info",
            name: "accountinfo",
            component: resolve => {
              require(["@/views/account/userInfo/UserInfo.vue"], resolve);
            },
            meta: { navtype: 1, },
          },
          {
            path: "pwd",
            name: "changePwd",
            component: resolve => {
              require(["@/views/account/userInfo/ChangePwd.vue"], resolve);
            },
            meta: { title: "修改密码", navtype: 1, },
          },
          {
            path: "changePwdOk",
            name: "changePwdOk",
            component: resolve => {
              require(["@/views/account/userInfo/ChangePwdOk.vue"], resolve);
            },
            meta: { title: "修改密码", navtype: 1, },
          },
        ]
      }
    ],
  },
];
export default account_route